import { Component } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-logo",
  imports: [UiKitModule],
  templateUrl: "./logo.component.html",
  styleUrl: "./logo.component.scss",
  standalone: true,
})
export class LogoComponent {}
